import { render, staticRenderFns } from "./CaptacaoUnidade.vue?vue&type=template&id=08cccd82&scoped=true&"
import script from "./CaptacaoUnidade.vue?vue&type=script&lang=js&"
export * from "./CaptacaoUnidade.vue?vue&type=script&lang=js&"
import style0 from "./CaptacaoUnidade.vue?vue&type=style&index=0&id=08cccd82&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08cccd82",
  null
  
)

export default component.exports